(function ($) {
  Drupal.behaviors.anr_repromote_carousel_v1 = {
    attach: function (context) {
      $('#anr_repromote_mod3', context).once(function (idx, element) {
        const $thismodule = $(element);
        const triggerMod = '#anr_repromote_mod3';
        const thisModuleName = 'anr_repromote_mod3';
        const controller = new ScrollMagic.Controller();
        const moduleWillFade = $thismodule.data('scrollmagic') === 1;
        const $leftCarouselStars = $thismodule.find('#js-anr_repromote_carousel__stars-left');
        const $carouselStarsLeft = $leftCarouselStars.find('.js-carousel_stars');
        const $rightCarouselStars = $thismodule.find('#js-anr_repromote_carousel__stars-right');
        const $carouselStarsRight = $rightCarouselStars.find('.js-carousel_stars');
        const $carousel__content = $thismodule.find('.js-anr_repromote_carousel__content');
        const $leftChevron = $thismodule.find('.js-el_boutique_carouselnav_1');
        const $rightChevron = $thismodule.find('.js-el_boutique_carouselnav_2');
        const urlHash = window.location.href.split('#')[1];
        let hasFaded = false;
        let counter = 1;
        let currentCount;
        const totalSlides = 5;
        let pagAnimating = false;
        const reset = 1;
        const marginResetLeft = 0;
        let offset, fadeThisModuleScene, isRTL, theDelay, chevronNum;
        const whichLeftStarsAnimate = [
          {
            startNum: 0,
            endNum: 4
          },
          {
            startNum: 4,
            endNum: 7
          },
          {
            startNum: 7,
            endNum: 10
          },
          {
            startNum: 9,
            endNum: 12
          },
          {
            startNum: 3,
            endNum: 8
          }
        ];
        const whichRightStarsAnimate = [
          {
            startNum: 0,
            endNum: 1
          },
          {
            startNum: 1,
            endNum: 2
          },
          {
            startNum: 2,
            endNum: 3
          },
          {
            startNum: 3,
            endNum: 4
          },
          {
            startNum: 2,
            endNum: 4
          }
        ];

        // If module is called in URL, scroll to module.
        if (urlHash === thisModuleName) {
          $('html,body').animate(
            {
              scrollTop: $thismodule.offset().top - 85
            },
            1500
          );
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        // new TimelineMax
        function timeLineSetup(whichStarGroup, whichStar, delay, transitionSpeed) {
          new TimelineMax({
            repeat: -1,
            yoyo: true,
            delay: delay
          })
            .set(whichStarGroup[whichStar], {
              opacity: '0.25'
            })
            .to(whichStarGroup[whichStar], transitionSpeed, {
              opacity: '1'
            });
        }

        // Animating the stars in the carousel.
        function handleStarsLeft(whichStarGroup, whichStar, delay, transitionSpeed) {
          timeLineSetup(whichStarGroup, whichStar, delay, transitionSpeed);
        }

        // Animating the stars in the carousel.
        function handleStarsRight(whichStarGroup, whichStar, delay, transitionSpeed) {
          timeLineSetup(whichStarGroup, whichStar, delay, transitionSpeed);
        }

        // Loop through multiple star animations.
        function loopThroughStars(startNum, endNum, whichFunc) {
          for (let theStarNum = startNum; theStarNum <= endNum; theStarNum++) {
            theDelay = 0 + (Math.random() * (0 - 0.8) + 0.8).toFixed(2);
            if (whichFunc === 'leftStars') {
              handleStarsLeft($carouselStarsLeft, theStarNum, theDelay, 0.8);
            } else {
              handleStarsRight($carouselStarsRight, theStarNum, theDelay, 0.8);
            }
          }
        }
        // Have some stars twinkling on page load.
        loopThroughStars(
          whichLeftStarsAnimate[0].startNum,
          whichLeftStarsAnimate[0].endNum,
          'leftStars'
        );
        loopThroughStars(
          whichRightStarsAnimate[0].startNum,
          whichRightStarsAnimate[0].endNum,
          'rightStars'
        );

        // 'Carousel' Animations.
        function events(count) {
          $('.js-anr_repromote_carousel__slide' + count)
            .addClass('fadeFromRight')
            .removeClass('hideContent')
            .siblings('.js-anr_repromote_carousel__slide')
            .removeClass('fadeFromRight')
            .addClass('hideContent');
          pagAnimating = false;
          currentCount = count - 1;
          TweenMax.killChildTweensOf($leftCarouselStars);
          TweenMax.killChildTweensOf($rightCarouselStars);
          $carouselStarsLeft.add($carouselStarsRight).css('opacity', 1);
          loopThroughStars(
            whichLeftStarsAnimate[currentCount].startNum,
            whichLeftStarsAnimate[currentCount].endNum,
            'leftStars'
          );
          loopThroughStars(
            whichRightStarsAnimate[currentCount].startNum,
            whichRightStarsAnimate[currentCount].endNum,
            'rightStars'
          );
        }

        function animatePagination(pagCount) {
          $thismodule.find('.js-anr_repromote_carousel_pag_dot' + pagCount).click(function () {
            if (pagAnimating === false) {
              pagAnimating = true;
              $(this).addClass('pagDotSelected').siblings().removeClass('pagDotSelected');
              counter = pagCount;
              events(pagCount);
            }
          });
        }
        for (let j = 1; j <= totalSlides; j++) {
          animatePagination(j);
        }

        // Check for RTL
        setTimeout(function () {
          if ($('html[dir="rtl"]').length) {
            isRTL = true;
          } else {
            return;
          }
        }, 1000);

        // Determine direction (RTL support)
        function negDirection() {
          counter++;
        }

        function posDirection() {
          counter--;
        }

        // Determine arrow
        function arrowDirection(arrowNo) {
          if (arrowNo === 1) {
            if (isRTL) {
              negDirection();
            } else {
              posDirection();
            }
          } else {
            if (isRTL) {
              posDirection();
            } else {
              negDirection();
            }
          }
        }

        // Carousel animation handling
        function animateCarousel() {
          $thismodule.find('.js-el_boutique_carouselnav').once(function () {
            $(this).click(function () {
              chevronNum = $(this).index() + 1;
              arrowDirection(chevronNum);
              if (counter === totalSlides + 1) {
                counter = reset;
              } else if (counter === marginResetLeft) {
                counter = totalSlides;
              }
              $('.js-anr_repromote_carousel_pag_dot' + counter).trigger('click');
            });
          });
        }
        animateCarousel();

        // Swipe the carousel
        function swipeCarousel() {
          if ($(window).width() < 768) {
            $carousel__content.swiperight(function () {
              $leftChevron.trigger('click');
            });
            $carousel__content.swipeleft(function () {
              $rightChevron.trigger('click');
            });
          }
        }
        swipeCarousel();

        $(window).on('load', function () {
          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.
            if ($thismodule.data('offset')) {
              offset = $thismodule.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });
            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
